import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Spinner, Alert } from 'react-bootstrap';
import { fetchTransactions } from '../../store/slices/walletSlice';
import TransactionItem from './TransactionItem';
import TransactionFilters from './TransactionFilters';

const TransactionHistory = () => {
  const dispatch = useDispatch();
  const { transactions, pagination, loading, error } = useSelector((s) => s.wallet);
  const [filters, setFilters] = useState({ type: '', from: '', to: '' });

  const load = useCallback(
    (cursor = null) => {
      const params = { limit: 20 };
      if (cursor) params.cursor = cursor;
      if (filters.type) params.type = filters.type;
      if (filters.from) params.from = filters.from;
      if (filters.to) params.to = filters.to;
      dispatch(fetchTransactions(params));
    },
    [dispatch, filters]
  );

  useEffect(() => {
    load();
  }, [load]);

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  return (
    <div>
      <h6 className="mb-3" style={{ fontWeight: 700 }}>
        Transaction History
      </h6>
      <TransactionFilters filters={filters} onChange={handleFiltersChange} />

      {error.transactions && (
        <Alert variant="danger" className="py-2 px-3" style={{ fontSize: 13 }}>
          {error.transactions}
        </Alert>
      )}

      {loading.transactions && transactions.length === 0 ? (
        <div className="text-center py-4">
          <Spinner animation="border" size="sm" />
        </div>
      ) : transactions.length === 0 ? (
        <p className="text-muted text-center py-4" style={{ fontSize: 14 }}>
          No transactions yet.
        </p>
      ) : (
        <>
          {transactions.map((txn) => (
            <TransactionItem key={txn.id} txn={txn} />
          ))}

          {pagination.hasMore && (
            <div className="text-center mt-3">
              <Button
                variant="outline-secondary"
                size="sm"
                disabled={loading.transactions}
                onClick={() => load(pagination.nextCursor)}
              >
                {loading.transactions ? <Spinner animation="border" size="sm" /> : 'Load More'}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default TransactionHistory;
